module.exports = __webpack_public_path__ + "img/CNHSOCIAL_MOTOCICLISTA.8aefbf17.png";